import gql from 'graphql-tag';

export const SIGN_IN = gql`
  mutation crmSignIn($username: String!, $password: String!) {
    crmSignIn(username: $username, password: $password) {
      token
    }
  }
`;
